module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isRegExp.js
// module id = 1651
// module chunks = 0